import { makeActionCreator } from '../../config/store/utils'
import { getSectorBiddings, getSectorBiddingKPIs } from '../../services/sectors'

export const GET_SECTOR_BIDDINGS = 'GET_SECTOR_BIDDINGS'
export const GET_SECTOR_BIDDINGS_ERROR = 'GET_SECTOR_BIDDINGS_ERROR'
export const GET_SECTOR_BIDDINGS_SUCCESS = 'GET_SECTOR_BIDDINGS_SUCCESS'
export const onGetSectorBiddings = makeActionCreator(GET_SECTOR_BIDDINGS)
export const onGetSectorBiddingsError = makeActionCreator(GET_SECTOR_BIDDINGS_ERROR, 'payload')
export const onGetSectorBiddingsSuccess = makeActionCreator(GET_SECTOR_BIDDINGS_SUCCESS, 'payload')
export const onGetSectorBiddingsThunk = payload => async dispatch => {
  dispatch(onGetSectorBiddings())

  try {
    const { data } = await getSectorBiddings({ sectorId: payload.id, year: payload.year })
    const enhancedData = data.payload
      .filter(
        (item1, index, collection) =>
          collection.findIndex(
            item2 => item2.biddingType === item1.biddingType && item2.quantityOCAnual === item1.quantityOCAnual
          ) === index
      )
      .map(item => ({
        amount: item.amountCLP || 0,
        amountUSD: item.amountUSD || 0,
        biddings: item.quantityLicAwardedAnual || 0,
        name: item.biddingDescription,
        orders: item.quantityOCAnual || 0,
        percentage: item.percentage || 0,
        year: item.year
      }))
    const csv = [
      [
        'Año',
        'Nombre',
        'Órdenes de compra',
        'Licitaciones adjudicadas',
        'Monto transado',
        'Monto transado (USD)',
        'Porcentaje'
      ],
      ...enhancedData.map(item => {
        return [item.year, item.name, item.orders, item.biddings, item.amount, item.amountUSD, item.percentage]
      })
    ]
    const totalAmount = enhancedData.reduce((total, item) => total + (item.amount || 0), 0)
    const totalAmountUSD = enhancedData.reduce((total, item) => total + (item.amountUSD || 0), 0)
    const totalBiddings = enhancedData.reduce((total, item) => total + (item.biddings || 0), 0)
    const totalOrders = enhancedData.reduce((total, item) => total + (item.orders || 0), 0)
    const totalPercentage = enhancedData.reduce((total, item) => total + (item.percentage || 0), 0)

    return dispatch(
      onGetSectorBiddingsSuccess({
        csv,
        totalAmount,
        totalAmountUSD,
        totalBiddings,
        totalOrders,
        totalPercentage,
        data: enhancedData
      })
    )
  } catch (error) {
    return dispatch(onGetSectorBiddingsError({ error }))
  }
}

export const GET_SECTOR_BIDDINGS_KPIS = 'GET_SECTOR_BIDDINGS_KPIS'
export const GET_SECTOR_BIDDINGS_KPIS_ERROR = 'GET_SECTOR_BIDDINGS_KPIS_ERROR'
export const GET_SECTOR_BIDDINGS_KPIS_SUCCESS = 'GET_SECTOR_BIDDINGS_KPIS_SUCCESS'
export const onGetSectorBiddingsKPIs = makeActionCreator(GET_SECTOR_BIDDINGS_KPIS)
export const onGetSectorBiddingsKPIsError = makeActionCreator(GET_SECTOR_BIDDINGS_KPIS_ERROR, 'payload')
export const onGetSectorBiddingsKPIsSuccess = makeActionCreator(GET_SECTOR_BIDDINGS_KPIS_SUCCESS, 'payload')
export const onGetSectorBiddingsKPIsThunk = payload => async dispatch => {
  dispatch(onGetSectorBiddingsKPIs())

  try {
    const { data } = await getSectorBiddingKPIs({ sectorId: payload.id, year: payload.year })
    const [item] = data.payload || []

    return dispatch(
      onGetSectorBiddingsKPIsSuccess({
        deserted: item.offersDesertYearly || 0,
        lessToTwo: item.offersSmallerThan3Yearly || 0,
        moreThanThree: item.offersGreaterThan3Yearly || 0
      })
    )
  } catch (error) {
    return dispatch(onGetSectorBiddingsKPIsError({ error }))
  }
}
